import React, { Component } from 'react'
import axios from 'axios'
import { Helmet } from "react-helmet"

// Components
import Loader from '../components/shared/Loader'
import Intro from '../components/home/Intro'
import Saludo from '../components/home/Saludo'
import MainInfo from '../components/home/MainInfo'
import LaCartaTitulo from '../components/home/LaCartaTitulo'
import LaCartaGrid from '../components/home/LaCartaGrid'
import LocalesTitulo from '../components/home/LocalesTitulo'
import LocalesGrid from '../components/home/LocalesGrid'
import LocalesInTitulo from '../components/home/LocalesInTitulo'
import LocalesIntGrid from '../components/home/LocalesIntGrid'
import Imagen from '../components/home/Imagen'
import RedesSociales from '../components/home/RedesSociales'
// import GridFacebook from '../components/home/GridFacebook'
import Footer from '../components/home/Footer'

// APIs
import { API_HOME_ES, API_HOME_EN } from '../utils/apiEndpoints.js'

// Facebook OpenGraph
import OP from '../utils/openGraph.js'

class HomeMain extends Component {
  state = {
    apiHome: [],
    apiES: API_HOME_ES,
    apiEN: API_HOME_EN,
    lang: '',
    isLoaded: false
  }

  // Get API endpoint
  getEndpoint() {
    const fullURL = window.location.host + window.location.pathname;
    if (fullURL.split('/')[1] === '') {
      const endPoint = this.state.apiES;
      this.setState({ lang: 'es' });
      return endPoint;

    } else if (fullURL.split('/')[1] === 'en') {
      const endPoint = this.state.apiEN;
      this.setState({ lang: 'en' });
      return endPoint;
    }
  }

  apiHome() {
    this.setState({ isLoaded: true});

    axios.get(this.getEndpoint())
      .then(response => {
        this.setState({
          apiHome: response.data.acf,
          isLoaded: false
        });
      })
      .catch(error => {
        console.log(error)
        this.setState({isLoaded: false});
      });
  }

  setTags() {
    return (
      <Helmet>
        <meta charset="utf-8" />
        <meta property="fb:app_id" content="158551348225083" />
        <meta property="og:type" content="article" />
        <title itemProp="name" lang="en">{this.state.lang === 'es' ? OP.es.home.titulo : OP.en.home.titulo}</title>
        <meta property="og:title" content={this.state.lang === 'es' ? OP.es.home.titulo : OP.en.home.titulo} />
        <meta name="description" content={this.state.lang === 'es' ? OP.es.home.desc : OP.en.home.desc} />
        <meta property="og:description" content={this.state.lang === 'es' ? OP.es.home.desc : OP.en.home.desc} />
        <meta property="og:url" content={this.state.lang === 'es' ? OP.es.home.link : OP.en.home.link} />
        <link rel="canonical" href={this.state.lang === 'es' ? OP.es.home.link : OP.en.home.link} />
        <meta property="og:image" content={OP.img.home} />
      </Helmet>
    )
  }

  componentDidMount() {
    this.getEndpoint();
    this.apiHome();
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }

  render() {
    let layer = <Loader />;

    if(!this.state.isLoaded) {
      layer = (
        <div>
          {this.setTags()}
          <Intro apiHome={this.state.apiHome} lang={this.state.lang} />
          <Saludo apiHome={this.state.apiHome} lang={this.state.lang} />
          <MainInfo apiHome={this.state.apiHome} lang={this.state.lang} />
          <LaCartaTitulo apiHome={this.state.apiHome} lang={this.state.lang} />
          <LaCartaGrid apiHome={this.state.apiHome} lang={this.state.lang} />
          <LocalesTitulo apiHome={this.state.apiHome} lang={this.state.lang} />
          <LocalesGrid apiHome={this.state.apiHome} lang={this.state.lang} />
          <LocalesInTitulo apiHome={this.state.apiHome} lang={this.state.lang} />
          <LocalesIntGrid apiHome={this.state.apiHome} lang={this.state.lang} />
          <Imagen apiHome={this.state.apiHome} />
          <RedesSociales lang={this.state.lang} />
          <Footer lang={this.state.lang} />
        </div>
      )
    }

    return layer;
    }
  }

  export default HomeMain;